import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Typography } from "@mui/material";


export default function TemporaryDrawer({
  open,
  onClose,
  onTabChange,
  activeTab,
  onSubTabChange,
  subTab,
}) {
  const [expandedTab, setExpandedTab] = useState(null);
  useEffect(() => {
    if (!open) {
      setExpandedTab(null); // Reset expanded tab when drawer closes
    }
  }, [open]);
  // Handle main tab click (Lauantai, Sunnuntai, etc.)
  const handleMainTabClick = (tab) => {
    if (tab === "lauantai") {
      setExpandedTab((prev) => (prev === "lauantai" ? null : "lauantai"));
      onTabChange("lauantai");
      onSubTabChange("u7"); // always reset to u7
    } else if (tab === "sunnuntai") {
      setExpandedTab((prev) => (prev === "sunnuntai" ? null : "sunnuntai"));
      onTabChange("sunnuntai");
      onSubTabChange("u8"); // always reset to u8
    }  else if (tab === "pukukopit") {
      setExpandedTab((prev) => (prev === "pukukopit" ? null : "pukukopit"));
      onTabChange("pukukopit");
      onSubTabChange("pukukoppiLa"); 
    }else {
      onTabChange(tab);
    }
  };
  

  // Handle sub-tab click (U7, U8, etc.)
  const handleSubTabClick = (tab) => {
    onSubTabChange(tab); // Change sub-tab

  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: 230,
          boxSizing: "border-box",
        },
      }}
      variant="temporary"
      anchor="left"
    >
      <Box sx={{ width: 150 }} role="presentation">
        <Box sx={{ mt: 12 }}> {/* Push content below AppBar */}
        <List sx={{ padding :0, margin: 0 }}> 
            {["turnausInfo", "lauantai", "sunnuntai", "pukukopit", "ruokailu", "kahvila"].map((tab) => (
              <React.Fragment key={tab}>
                <ListItem disablePadding sx={{ padding: '0px' }} >
                  <ListItemButton onClick={() => handleMainTabClick(tab)
                   }
                   sx={{ padding: '6px 16px',
                          mr:-7 }}
                   >
                <ListItemText
                    primary={
                        <Typography
                        sx={{
                            fontSize: "0.85rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap"
                        }}
                        >
                        {tab === "turnausInfo"
                        ? "AUTOSALPA-Turnaus Info"
                        : tab === "lauantai"
                        ? "Lauantai ohjelma"
                        : tab === "sunnuntai"
                            ? "Sunnuntai ohjelma"
                        :tab ==='lamaritutka'
                            ?"Lämäritutka - kilpailu"
                        :tab ==="gameChangerResult"
                            ? "GameChanger - kilpailu"
                        :tab ==='pukukoppiLa'
                            ? 'Lauantai Pukukoppijako'
                            :tab ==='pukukoppiSun'
                            ? 'Sunnuntai Pukukoppijako'
                            : tab.charAt(0).toUpperCase() + tab.slice(1)}
                            
                        </Typography>
                    }
                    />
                  </ListItemButton>
                </ListItem>

                {/* Show sub-tabs only if tab is expanded */}
                {tab === "lauantai" && expandedTab === "lauantai" && (
                  <>
                    <ListItem disablePadding>
                      <ListItemButton selected={subTab === "u7"} 
                      onClick={() => handleSubTabClick("u7")}
                      sx={{
                        px: 2,
                        py: 1,
                        ml: 5,
                        mr:-9,
                      }}>
                        <ListItemText primary={
                        <Typography
                        sx={{
                            fontSize: "0.8rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap",
                            textAlign:"left",
                        }}
                        >
                        U7 otteluohjelma
                        </Typography>
                    }

                          />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton selected={subTab === "u8"} 
                      onClick={() => handleSubTabClick("u8")}
                      sx={{
                        px: 2,
                        py: 1,
                        ml: 5,
                        mr:-9,
                      }}>
                        <ListItemText primary={
                        <Typography
                        sx={{
                            fontSize: "0.8rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap",
                            textAlign:"left",
                        }}
                        >
                        U8 Otteluohjelma
                        </Typography>
                    }
              
                          />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton selected={subTab === "lamaritutka"} 
                      onClick={() => handleSubTabClick("lamaritutka")}
                      sx={{
                        px: 2,
                        py: 1,
                        ml: 5,
                        mr:-9,
                      }}>
                        <ListItemText primary={
                        <Typography
                        sx={{
                            fontSize: "0.8rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap",
                            textAlign:"left",
                        }}
                        >
                        Lämäritutka- kilpailu
                        </Typography>
                    }
                        
                          />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton selected={subTab === "gameChangerResult"} 
                      onClick={() => handleSubTabClick("gameChangerResult")}
                      sx={{
                        px: 2,
                        py: 1,
                        ml: 5,
                        mr:-9
                      }}>
                        <ListItemText primary={
                        <Typography
                        sx={{
                            fontSize: "0.8rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap",
                            textAlign:"left",
                        }}
                        >
                        GameChanger - kilpailu
                        </Typography>
                    }
                       
                          />
                      </ListItemButton>
                    </ListItem>
                  </>
                )}
                
                {tab === "sunnuntai" && expandedTab === "sunnuntai" && (
                  <>
                    <ListItem disablePadding>
                      <ListItemButton selected={subTab === "u8"} 
                      onClick={() => handleSubTabClick("u8")}
                      sx={{
                        px: 2,
                        py: 1,
                        ml: 5,
                        mr:-9,
                      }}>
                        <ListItemText primary={
                        <Typography
                        sx={{
                            fontSize: "0.8rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap",
                            textAlign:'left'
                        }}
                        >
                        U8 Otteluohjelma
                        </Typography>
                        }
                          />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton selected={subTab === "u9"} 
                      onClick={() => handleSubTabClick("u9")}
                      sx={{
                        px: 2,
                        py: 1,
                        ml: 5,
                        mr:-9,
                      }}>
                        
                        <ListItemText primary={
                        <Typography
                        sx={{
                            fontSize: "0.8rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap",
                            textAlign:'left'
                        }}
                        >
                        U9 Otteluohjelma
                        </Typography>
                    }
                          />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton selected={subTab === "lamaritutkaSun"} 
                      onClick={() => handleSubTabClick("lamaritutkaSun")}
                      sx={{
                        px: 2,
                        py: 1,
                        ml: 5,
                        mr:-9,
                      }}>
                        <ListItemText primary={
                        <Typography
                        sx={{
                            fontSize: "0.8rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap",
                            textAlign:'left'
                        }}
                        >
                        Lämäritutka- kilpailu
                        </Typography>
                    }
                          />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton selected={subTab === "gameChangerResultSun"} 
                      onClick={() => handleSubTabClick("gameChangerResultSun")}
                      sx={{
                        px: 2,
                        py: 1,
                        ml: 5,
                        mr:-9,
                      }}>
                        <ListItemText primary={
                        <Typography
                        sx={{
                            fontSize: "0.8rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap",
                            textAlign:"center",
                        }}
                        >
                        GameChanger - kilpailu
                        </Typography>
                    }

                          />
                      </ListItemButton>
                    </ListItem>
                  </>
                )}

                {tab === "pukukopit" && expandedTab === "pukukopit" && (
                  <>
                    <ListItem disablePadding>
                      <ListItemButton selected={subTab === "pukukoppiLa"} 
                      onClick={() => handleSubTabClick("pukukoppiLa")}
                      sx={{
                        px: 2,
                        py: 1,
                        ml: 5,
                        mr:-8,
                      }}>
                        <ListItemText primary={
                        <Typography
                        sx={{
                            fontSize: "0.8rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap",
                            textAlign:'left'
                           
                        }}
                        >
                        Lauantai      
                        </Typography>
                    }
                        sx={{
                            textAlign:"center",
                            width:"100%",
                         // Prevent text wrapping
                          }}
                          />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton selected={subTab === "pukukoppiSun"} 
                      onClick={() => handleSubTabClick("pukukoppiSun")}
                      sx={{
                        px: 2,
                        py: 1,
                        ml: 5,
                        mr:-8,
                      }}>
                        <ListItemText primary={
                        <Typography
                        sx={{
                            fontSize: "0.8rem", // adjust as needed
                            fontWeight: "normal",
                            whiteSpace: "nowrap",
                            textAlign:'left'
                        }}
                        >
                        Sunnuntai
                        </Typography>
                    }
                        sx={{
                            textAlign:"center",
                         // Prevent text wrapping
                          }}
                          />
                      </ListItemButton>
                    </ListItem>
                  </>
                )}

              </React.Fragment>
            ))}
          </List>
        </Box>
        <Divider />
      </Box>
    </Drawer>
  );
}